var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98116 14.5904C3.15108 14.5904 0.842285 16.9032 0.842285 19.737V24.3723C0.843223 24.6507 0.954785 24.9174 1.1526 25.1138C1.35018 25.31 1.61783 25.4197 1.8963 25.4185H18.1035C18.3819 25.4196 18.6496 25.31 18.8472 25.1138C19.045 24.9174 19.1566 24.6507 19.1575 24.3723V19.737C19.1575 16.9032 16.8487 14.5904 14.0186 14.5904H5.98116ZM5.98116 16.6909H14.0188C15.7177 16.6909 17.0572 18.0266 17.0572 19.7371V23.3181H2.94282V19.7371C2.94282 18.0266 4.28202 16.6909 5.98128 16.6909H5.98116Z",
    fill: "#686777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99589 0.181458C6.83791 0.181458 4.26025 2.75444 4.26025 5.90936C4.26025 9.06428 6.83791 11.645 9.99589 11.645C13.1539 11.645 15.7395 9.06428 15.7395 5.90936C15.7395 2.75444 13.1541 0.181458 9.99589 0.181458ZM9.99589 2.28194C12.0214 2.28194 13.6388 3.89162 13.6388 5.90936C13.6388 7.9271 12.0211 9.54452 9.99589 9.54452C7.97041 9.54452 6.36073 7.9271 6.36073 5.90936C6.36073 3.89162 7.97065 2.28194 9.99589 2.28194Z",
    fill: "#686777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUserIcon);
export default __webpack_public_path__ + "static/media/menu-user-icon.27ca281b953cfb70a85f6189ec7345de.svg";
export { ForwardRef as ReactComponent };